import { AppProvider, AppType, AppContextProps } from '@features/contexts/AppProvider';
import { PropsWithChildren } from 'react';
import { clinicalLogStyleKeyByPlatform } from '@features/components/ClinicalData/components/ClinicalLog/constants';
import { CLINICAL_ITEM_TYPE_TO_TEXT } from '@features/components/ClinicalData/constants';
import { etaContent } from '@lp/features/CaseOverview/components/Tabs/CaseDetails/config';
import { StreamChannelType } from '@/api/apis/chat';

const APP_CONFIG: AppContextProps = {
  type: AppType.NopConnectPlatform,
  caseDetails: { etaContent },
  clinicalLog: {
    names: CLINICAL_ITEM_TYPE_TO_TEXT,
    styles: clinicalLogStyleKeyByPlatform[AppType.NopConnectPlatform],
  },
  chartConfig: {
    barChart: { showMaxValueIndicator: true, showBarDiff: true },
  },
  chatConfig: {
    excludedChannelTypesToShare: [StreamChannelType.Quote, StreamChannelType.Logistics],
  },
};

export const LogisticsPlatformAppProvider = ({ children }: PropsWithChildren) => (
  <AppProvider config={APP_CONFIG}>{children}</AppProvider>
);
